module.exports = __webpack_public_path__ + "img/m2.d743af1b.png";